/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ShiftScheduleInputDto interface.
 */
export function instanceOfShiftScheduleInputDto(value) {
    return true;
}
export function ShiftScheduleInputDtoFromJSON(json) {
    return ShiftScheduleInputDtoFromJSONTyped(json, false);
}
export function ShiftScheduleInputDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'deltaMonths': json['deltaMonths'] == null ? undefined : json['deltaMonths'],
        'shiftStaff': json['shiftStaff'] == null ? undefined : json['shiftStaff'],
        'shiftExternalCost': json['shiftExternalCost'] == null ? undefined : json['shiftExternalCost'],
        'shiftRevenue': json['shiftRevenue'] == null ? undefined : json['shiftRevenue'],
    };
}
export function ShiftScheduleInputDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'deltaMonths': value['deltaMonths'],
        'shiftStaff': value['shiftStaff'],
        'shiftExternalCost': value['shiftExternalCost'],
        'shiftRevenue': value['shiftRevenue'],
    };
}
